<template>
  <v-container grid-list-md>
    <v-layout row
              wrap>

      <template v-for="(item, index) in videos">
        <v-flex xs12
                md6
                :key="index">
          <v-card>
            <div class="video-container">
              <iframe :src="item.link"
                      frameborder="0"
                      allow="autoplay; encrypted-media"
                      allowfullscreen></iframe>
            </div>
          </v-card>
        </v-flex>
      </template>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  name: 'Help',
  components: {},
  data() {
    return {
      videos: [
        {
          link: 'https://www.youtube.com/embed/fM3geE6ibOY?rel=0&amp;showinfo=0&amp;cc_load_policy=1'
        },

        {
          link: 'https://www.youtube.com/embed/YbCR3KNXKlc?rel=0&amp;showinfo=0&amp;cc_load_policy=1'
        },

        {
          link: 'https://www.youtube.com/embed/j8m9Bt2V7PQ?rel=0&amp;showinfo=0&amp;cc_load_policy=1'
        },

        {
          link: 'https://www.youtube.com/embed/M8eQS0OVIOk?rel=0&amp;showinfo=0&amp;cc_load_policy=1'
        },

        {
          link: 'https://www.youtube.com/embed/CcAwdaMV_iE?rel=0&amp;showinfo=0&amp;cc_load_policy=1'
        },

        {
          link: 'https://www.youtube.com/embed/bkfRqCBv3hw?rel=0&amp;showinfo=0&amp;cc_load_policy=1'
        },

        {
          link: 'https://www.youtube.com/embed/077x--VzFis?rel=0&amp;showinfo=0&amp;cc_load_policy=1'
        },

        {
          link: 'https://www.youtube.com/embed/f5HVGMs4VxI?rel=0&amp;showinfo=0&amp;cc_load_policy=1'
        }
      ]
    };
  }
};
</script>

// https://victorroblesweb.es/2017/05/13/iframe-videos-youtube-responsive/
<style scoped>
.video-container {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px;
  height: 0;
  overflow: hidden;
}

.video-container iframe,
.video-container object,
.video-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/help/Help.vue